module.exports = __webpack_public_path__ + "static/media/rutgers-logo.a7ddfce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/rutgers-logo.png
// module id = 949
// module chunks = 0